<template>
  <O3D :py="(baseZ) * floor" v-if="ready">
    <!-- Floor -->
    <CBMesh :sx="baseWidth * 2" :sy="0.2" :sz="baseHeight * 2" :mat="'whiteFloor'"></CBMesh>
    <!-- Ceiling -->
    <CBMesh :sx="baseWidth * 2" :py="baseZ" :sy="0.2" :sz="baseHeight * 2" :mat="'whiteFloor'"></CBMesh>
    <!-- 4walls -->
    <O3D :layout="'wall1'">
      <CBMesh :sx="baseWidth * 2" :py="baseZ * 0.5" :sy="baseZ" :sz="0.2" :mat="'whiteFloor'"></CBMesh>
    </O3D>
    <O3D :layout="'wall2'" :visible="false">
      <CBMesh :sx="baseWidth * 2" :py="baseZ * 0.5" :sy="baseZ" :sz="0.2" :mat="'glassWindow'"></CBMesh>
    </O3D>

    <O3D :layout="'wall3'">
      <CBMesh :sx="baseHeight * 2" :py="baseZ * 0.5" :sy="baseZ" :sz="0.2" :mat="'whiteFloor'"></CBMesh>
    </O3D>
    <O3D :layout="'wall4'">
      <CBMesh :sx="baseHeight * 2" :py="baseZ * 0.5" :sy="baseZ" :sz="0.2" :mat="'whiteFloor'"></CBMesh>
    </O3D>

    <slot></slot>

  </O3D>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { MeshBasicMaterial, MeshStandardMaterial, DoubleSide } from 'three'
export default {
  props: {
    floor: {}
  },
  mixins: [O3DG2],
  data () {
    return {
      baseWidth: 50,
      baseHeight: 80,
      baseZ: 30,
      layouts: {},
      whiteMat: false,
      ready: false,
    }
  },
  methods: {
    setup () {
      this.whiteFloor = new MeshStandardMaterial({ side: DoubleSide, color: 0xffffff, opacity: 0.25, transparent: true })
      this.glassWindow = new MeshBasicMaterial({ side: DoubleSide, color: 0xffffff, opacity: 0.25, transparent: true })
      this.ready = true
      this.layouts = {
        wall1: {
          ry: 1.0 * this.pi,
          pz: -this.baseHeight
        },
        wall2: {
          ry: 1.0 * this.pi,
          pz: this.baseHeight
        },
        wall3: {
          ry: 1.5 * this.pi,
          px: this.baseWidth
        },
        wall4: {
          ry: 1.5 * this.pi,
          px: -this.baseWidth
        }
      }
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>